import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/home";
import BlogPost from "./components/blogPost"; 

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:entryId" element={<BlogPost />} /> {/* Dynamic ID handling */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
